var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIris(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3334_32733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.28406 17.3927L1.77846 18.0119L5.01126 10.5527L1.70166 6.04075L9.74886 5.12395L11.9353 0.0959473L16.7257 6.60715L22.2313 5.98795L19.0129 13.4111L22.2985 17.8919L14.2921 18.8039L12.0721 23.9039L7.28406 17.3927ZM9.57126 16.8983C9.36006 17.0015 9.13446 17.0879 8.90166 17.1527L8.69046 17.2103L11.7937 21.4295L12.8953 18.8951L12.6961 18.8687C11.6113 18.7319 10.6249 18.1463 9.98886 17.2679L9.67926 16.8407L9.57126 16.8983ZM8.49126 13.0727L10.9945 16.5359C11.5033 17.2391 12.3265 17.6591 13.1953 17.6591C13.2961 17.6591 13.3969 17.6543 13.4953 17.6423L20.0281 16.8983L17.4265 13.3487C17.2969 13.1735 17.1481 13.0151 16.9825 12.8759L16.8289 12.7487L14.9665 16.9559L11.7265 12.6671L8.49126 13.0727ZM8.59926 8.85595C7.62966 8.95915 6.78486 9.58075 6.39606 10.4783L3.77286 16.5335L8.13126 16.0439C8.34726 16.0199 8.55846 15.9695 8.76246 15.8951L8.94966 15.8255L6.25206 12.1007L11.5705 11.4263L12.8353 8.40475L8.59926 8.85595ZM12.7153 11.9111L14.6857 14.5199L15.8881 11.8055L16.4161 10.6103C16.8121 9.71515 16.6993 8.67115 16.1185 7.88395L12.2137 2.57035L10.4569 6.60715C10.3705 6.80635 10.3081 7.01515 10.2697 7.23115L10.2361 7.42795L14.7937 6.94555L12.7153 11.9111ZM17.5033 7.77355L17.5801 7.95835C18.0025 8.96875 17.9929 10.1207 17.5513 11.1167L17.3377 11.5967L17.4409 11.6663C17.6377 11.7983 17.8225 11.9519 17.9929 12.1223L18.1489 12.2759L20.2345 7.46395L17.5033 7.77355ZM3.97206 7.03435L5.63286 9.29995L5.75526 9.14155C6.41526 8.28475 7.40646 7.72795 8.46966 7.61515L8.99046 7.55995L9.00006 7.43275C9.01686 7.17115 9.06246 6.90955 9.13206 6.65515L9.19206 6.43915L3.97206 7.03435Z",
    fill: "url(#paint0_linear_3334_32733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8385 24C7.38254 23.6664 4.27694 21.8688 2.24414 19.02L3.63614 18.864C3.86654 19.1472 4.11134 19.4184 4.36334 19.6728C5.87294 21.1896 7.76174 22.212 9.83294 22.6344L10.8385 24Z",
    fill: "url(#paint1_linear_3334_32733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7374 22.7111C15.979 22.3487 18.0166 21.2999 19.6366 19.6727C19.7806 19.5263 19.927 19.3703 20.0734 19.2071L21.7606 19.0151C19.735 21.8615 16.6342 23.6615 13.1782 23.9999L13.7374 22.7111Z",
    fill: "url(#paint2_linear_3334_32733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.104 15.8472C22.5648 14.6208 22.8 13.3272 22.8 12C22.8 10.8288 22.6152 9.67678 22.2528 8.57758L22.9296 7.01758C23.64 8.58478 24 10.26 24 12C24 13.7376 23.64 15.4104 22.932 16.9776L22.104 15.8472Z",
    fill: "url(#paint3_linear_3334_32733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0752 16.9945C0.3624 15.4225 0 13.7449 0 12.0001C0 10.2457 0.3648 8.55849 1.0872 6.98169L1.9128 8.10969C1.44 9.34809 1.2 10.6561 1.2 12.0001C1.2 13.1761 1.3848 14.3305 1.7496 15.4345L1.0752 16.9945Z",
    fill: "url(#paint4_linear_3334_32733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.29443 4.9104C4.32483 2.1072 7.40643 0.3312 10.8312 0L10.272 1.2864C8.02803 1.6464 5.98563 2.6976 4.36323 4.3272C4.24083 4.4496 4.11843 4.5816 3.99603 4.716L2.29443 4.9104Z",
    fill: "url(#paint5_linear_3334_32733)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3666 5.136C20.1362 4.8528 19.8914 4.5816 19.637 4.3272C18.1298 2.8128 16.2434 1.7904 14.177 1.368L13.1714 0C16.625 0.336 19.7258 2.1336 21.7562 4.98L20.3666 5.136Z",
    fill: "url(#paint6_linear_3334_32733)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3334_32733",
    x1: 2.3064,
    y1: 21.66,
    x2: 21.0259,
    y2: 2.94049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3334_32733",
    x1: 4.34888,
    y1: 23.7025,
    x2: 23.0684,
    y2: 4.98296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3334_32733",
    x1: 9.68927,
    y1: 29.0431,
    x2: 28.4088,
    y2: 10.3236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3334_32733",
    x1: 7.78734,
    y1: 27.141,
    x2: 26.5069,
    y2: 8.42152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3334_32733",
    x1: -3.14226,
    y1: 16.2115,
    x2: 15.5773,
    y2: -2.50797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3334_32733",
    x1: -5.04038,
    y1: 14.3133,
    x2: 13.6791,
    y2: -4.40621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3334_32733",
    x1: 0.300121,
    y1: 19.6537,
    x2: 19.0196,
    y2: 0.934144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#694D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3554"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3334_32733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIris);
export default __webpack_public_path__ + "static/media/iris.1317734d6e8493d59847241aa97ff691.svg";
export { ForwardRef as ReactComponent };